import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ApplicationInsightsService } from './app-insights.service';
import { appConfig } from 'src/app/models/constants';

@Injectable({ providedIn: 'root' })
export class ApplicationInsightsErrorHandler implements ErrorHandler{

  constructor(private injector : Injector)
  {
  }

  handleError(error: any): void {
    console.error(error);

    if (appConfig.appConfigService?.appInsights?.enable)
    this.injector.get<ApplicationInsightsService>(ApplicationInsightsService).logException(error);
  }
}

